import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import * as moment from 'moment';
import { CurrentUser } from '../model/CurrentUser';

@Injectable({
  providedIn: 'root'
})
export class PatientAuthenticationService {

  currentUserSubject: any;
  currentUser: any;

  constructor(
    private http: HttpClient,
  ) {
  }

  getCurrentUser(): any {
    return JSON.parse(localStorage.getItem('storedPatient'));
  }

  logout() {
    // logout of the current patient
  }

  storePatientToken(patientToken) {

    if ((patientToken.access_token != '') && (patientToken.access_token != null)) {
      localStorage.setItem("TDOPatientAuthToken", patientToken.access_token);
      const expiresAt = moment().add(patientToken.expiresIn, 'second');
      var currentUser: CurrentUser = new CurrentUser();
      currentUser.webclientid = patientToken.webclientid;
      currentUser.TDOCID = patientToken.TDOCID;
      currentUser.authdata = patientToken;
      currentUser.callingapp = 'TDOx';
      currentUser.firstname = '';
      currentUser.lastname = ''
      currentUser.nickname = patientToken.usernickname;

      currentUser.fullname = patientToken.userfullname;
      currentUser.TDOGuid = patientToken.TDOGuid;

      currentUser.userdisplayname = patientToken.userdisplayname;
      currentUser.userroles = patientToken.userroles;
      currentUser.authtoken = patientToken.access_token;
      currentUser.expires_at = JSON.stringify(expiresAt.valueOf());

      localStorage.setItem("storedPatient", JSON.stringify(currentUser));


      return true;
    }
    else
    {
      return false;
    }

  }

}
